interface PartnerFieldLabelProps {
  htmlFor: string;
  required?: boolean;
  children: React.ReactNode;
}

/**
 * Label for one field on the Partner sign-up form, with a red asterisk on required fields.
 *
 * @param props - See {@link PartnerFieldLabelProps}.
 * @returns The label.
 */
export default function PartnerFieldLabel({ htmlFor, required = false, children }: PartnerFieldLabelProps) {
  return (
    <label htmlFor={htmlFor} className="text-sm font-semibold text-gray-700">
      {children}
      {/* Visual cue only. The field's `required` attribute tells screen readers. */}
      {required && (
        <span className="text-red-500" aria-hidden="true">
          *
        </span>
      )}
    </label>
  );
}
